export default [
	{
		path: "agenda",
		meta: {
      helpTag: "party:agenda",
    },
    component: () =>
			import(
				"../../views/general/agenda"
			),
			children: [
				{
					path: "",
					name: "Party.Agenda",
					component: () =>
						import(
							"../../views/general/agenda/list"
						),
				},
				{
					path: ":hexkey/:ap_hexkey([a-z0-9]{32})?",
					name: "Party.Agenda.Details",
					component: () =>
						import(
							"../../views/general/agenda/agenda.vue"
						),
				},
			],
  },
  {
    path: "agenda/:hexkey",
    meta: {
      helpTag: "party:agendavideo"
    },
    component: () => import("../../views/council-public/agendavideo"),
    children: [
      {
        path: "vod/:ap_hexkey?",
        name: "Party.AgendaVideo.VOD",
        component: () =>
          import(
            "../../views/council-public/agendavideo/vod"
          ),
      },
      {
        path: "live",
        name: "Party.AgendaVideo.Live",
        component: () =>
          import(
            "../../views/council-public/agendavideo/live"
          ),
      },
    ],
  },
];